
import ko from './ko/common';
import en from './en/common';
import ru from './ru/common';

export default {
  ko: {
    translation: ko,
  },
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
};
